"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import './../../sass/cookies.sass';
import '@orestbida/iframemanager';
import '@orestbida/iframemanager/dist/iframemanager.css';
import * as CookieConsent from "vanilla-cookieconsent";
import "vanilla-cookieconsent/dist/cookieconsent.css";
class Cookies {
    constructor(gtmId, sklikAdConfig) {
        this.gtmId = gtmId;
        this.sklikAdConfig = sklikAdConfig;
        this.cookieConsentState = {
            sklikScriptLoaded: false,
            heurekaScriptLoaded: false,
            previousConsent: this.loadPreviousConsent() || { analytics: false, ad: false }
        };
        this.init();
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadGTM();
            this.initIframeManager();
            this.initCookieConsent();
        });
    }
    loadGTM() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.loadScriptOnce(`https://www.googletagmanager.com/gtm.js?id=${this.gtmId}`);
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
                console.log('GTM loaded successfully');
            }
            catch (error) {
                console.error('Failed to load GTM:', error);
            }
        });
    }
    initIframeManager() {
        const iframemanager = window.iframemanager();
        iframemanager.run({
            currLang: document.documentElement.getAttribute('lang'),
            services: {
                youtube: {
                    embedUrl: 'https://www.youtube-nocookie.com/embed/{data-id}',
                    iframe: {
                        allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;'
                    },
                    cookie: {
                        name: 'cc_youtube'
                    },
                    languages: {
                        'cs': {
                            notice: '<span class="h2">Youtube video</span><br><br>Tento obsah je hostován třetí stranou. Zobrazením externího obsahu přijímáte <a rel="noreferrer" href="https://www.youtube.com/t/terms" title="Podmínky" target="_blank">podmínky</a> youtube.com.',
                            loadBtn: 'Přehrát',
                            loadAllBtn: 'Povolit načítání všech youtube videí',
                        }
                    }
                }
            }
        });
    }
    initCookieConsent() {
        CookieConsent.run({
            guiOptions: {
                consentModal: {
                    layout: 'box wide',
                    position: 'bottom right',
                    equalWeightButtons: true,
                    flipButtons: false,
                },
                preferencesModal: {
                    layout: 'box',
                    equalWeightButtons: true,
                    flipButtons: false,
                },
            },
            categories: {
                necessary: {
                    readOnly: true,
                    enabled: true,
                },
                analytics: {
                    services: {
                        ga: {
                            label: 'Google Analytics'
                        },
                        youtube: {
                            label: 'YouTube',
                            onAccept: () => window.iframemanager().acceptService('youtube'),
                            onReject: () => window.iframemanager().rejectService('youtube')
                        },
                    },
                },
                targeting: {
                    services: {
                        sklik: {
                            label: 'Sklik Reklamy'
                        },
                        heureka: {
                            label: 'Heureka Reklamy',
                        }
                    },
                }
            },
            language: {
                default: 'cs',
                translations: { cs: '/www/json/cs.json' },
            },
            onFirstConsent: (userPreferences) => this.handleConsentUpdate(userPreferences),
            onConsent: (userPreferences) => this.handleConsentUpdate(userPreferences),
            onChange: () => this.handleConsentUpdate(CookieConsent.getUserPreferences()),
        });
    }
    handleConsentUpdate(userPreferences) {
        return __awaiter(this, void 0, void 0, function* () {
            const consent = this.extractConsent(userPreferences);
            if (JSON.stringify(consent) !== JSON.stringify(this.cookieConsentState.previousConsent)) {
                this.updateGTMConsent(consent);
                this.saveConsentState(consent);
                this.cookieConsentState.previousConsent = consent;
                console.log('Update GTM!');
            }
            if (consent.ad) {
                if (this.sklikAdConfig) {
                    yield this.loadSklikAdsIfNeeded(this.sklikAdConfig);
                }
                yield this.loadHeurekaAdsIfNeeded();
            }
            else {
                this.removeSklikAds();
            }
        });
    }
    extractConsent(userPreferences) {
        const cookie = (userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.cookie) || {};
        const categories = cookie.categories || [];
        const services = cookie.services || {};
        return {
            analytics: categories.includes('analytics') && Array.isArray(services.analytics) && services.analytics.length > 0,
            ad: categories.includes('targeting') && Array.isArray(services.targeting) && services.targeting.length > 0,
        };
    }
    loadScriptOnce(src) {
        return __awaiter(this, void 0, void 0, function* () {
            const existingScript = document.querySelector(`script[src="${src}"]`);
            if (!existingScript) {
                return new Promise((resolve, reject) => {
                    const script = document.createElement('script');
                    script.src = src;
                    script.async = true;
                    script.onload = resolve;
                    script.onerror = reject;
                    document.head.appendChild(script);
                });
            }
            else {
                return Promise.resolve();
            }
        });
    }
    loadSklikAdsIfNeeded(adConfigs) {
        return __awaiter(this, void 0, void 0, function* () {
            const shouldLoadSklik = adConfigs.some(adConfig => document.getElementById(adConfig.id));
            if (shouldLoadSklik) {
                try {
                    yield this.loadScriptOnce('https://ssp.seznam.cz/static/js/ssp.js');
                    this.cookieConsentState.sklikScriptLoaded = true;
                    if (typeof window.sssp !== 'undefined') {
                        adConfigs.forEach(adConfig => {
                            const { zoneId, id, width, height } = adConfig;
                            if (document.getElementById(id)) {
                                window.sssp.getAds([{ zoneId, id, width, height }]);
                            }
                        });
                    }
                }
                catch (error) {
                    console.error('Failed to load Sklik ads:', error);
                }
            }
        });
    }
    loadHeurekaAdsIfNeeded() {
        return __awaiter(this, void 0, void 0, function* () {
            const shouldLoadHeureka = document.querySelector('[data-trixam-positionid]');
            if (shouldLoadHeureka) {
                yield this.loadScriptOnce('https://serve.affiliate.heureka.cz/js/trixam.min.js');
                this.cookieConsentState.heurekaScriptLoaded = true;
            }
        });
    }
    updateGTMConsent(consent) {
        if (window.dataLayer) {
            window.dataLayer.push({
                'gtm.consent': {
                    'ad_storage': consent.ad ? 'granted' : 'denied',
                    'analytics_storage': consent.analytics ? 'granted' : 'denied'
                }
            });
        }
    }
    removeSklikAds() {
        const scripts = document.querySelectorAll('script[src*="ssp.seznam.cz/static/js/ssp.js"]');
        scripts.forEach(script => script.remove());
        const adZones = document.querySelectorAll('[id^="ssp-zone-"]');
        adZones.forEach(zone => { zone.innerHTML = ''; });
    }
    loadPreviousConsent() {
        const consentState = localStorage.getItem('cookieConsentState');
        return consentState ? JSON.parse(consentState) : null;
    }
    saveConsentState(consent) {
        localStorage.setItem('cookieConsentState', JSON.stringify(consent));
    }
}
document.addEventListener('DOMContentLoaded', () => {
    const gtmId = "GTM-MNLC8TR";
    const sklikAdConfig = [
        {
            "zoneId": 75473,
            "id": "ssp-zone-75473",
            "width": 300,
            "height": 600
        }, {
            "zoneId": 99560,
            "id": "ssp-zone-99560",
            "width": 480,
            "height": 300
        }
    ];
    new Cookies(gtmId, sklikAdConfig);
}, false);
